// @ts-check
import { STATUS_DOT_GREEN_SVG, STATUS_DOT_RED_SVG } from '../../shared/icons.js';

/**
 * Syncs visual + accessible state for lobby-visibility Active/Off toggles.
 * Title alone is not enough for screen readers / touch; keep aria-pressed and aria-label in sync.
 *
 * @param {HTMLElement|null|undefined} btn
 * @param {boolean} isActive
 */
export function syncLobbyVisibilityToggle(btn, isActive) {
  if (!btn) return;
  const nextVal = isActive ? '1' : '0';
  btn.setAttribute('data-active', nextVal);
  btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  btn.setAttribute(
    'aria-label',
    isActive ? 'Lobby visibility: Active. Click to disable' : 'Lobby visibility: Off. Click to enable'
  );
  btn.innerHTML = `${isActive ? STATUS_DOT_GREEN_SVG : STATUS_DOT_RED_SVG} ${isActive ? 'Active' : 'Off'}`;
  if (!btn.textContent) {
    btn.textContent = isActive ? 'Active' : 'Off';
  }
  btn.title = isActive ? 'Click to disable' : 'Click to enable';
  btn.className = isActive ? 'btn btn-secondary' : 'btn btn-danger';
}
